import {
  pluginVideoLoadable as pluginVideo,
  pluginDividerLoadable as pluginDivider,
  pluginImageLoadable as pluginImage,
  pluginGalleryLoadable as pluginGallery,
  pluginLinkLoadable as pluginLink,
  pluginGiphyLoadable as pluginGiphy,
  pluginHtmlLoadable as pluginHtml,
  pluginFileUploadLoadable as pluginFileUpload,
  pluginLinkPreviewLoadable as pluginLinkPreview,
  pluginAudioLoadable as pluginAudio,
  pluginVerticalEmbedLoadable as pluginVerticalEmbed,
  pluginTableLoadable as pluginTable,
  pluginLinkButtonLoadable as pluginLinkButton,
} from '@wix/ricos/loadable';

import {
  pluginTextColorViewer as pluginTextColor,
  pluginTextHighlightViewer as pluginTextHighlight,
} from '@wix/ricos';

const PLUGINS = [
  pluginVideo(),
  pluginDivider(),
  pluginImage({
    disableTransition: true,
  }),
  pluginGallery(),
  pluginLink(),
  pluginGiphy(),
  pluginHtml(),
  pluginFileUpload(),
  pluginLinkPreview(),
  pluginTextColor(),
  pluginTextHighlight(),
  pluginVerticalEmbed(),
  pluginTable(),
  pluginAudio(),
  pluginLinkButton(),
];

export const rceUtils = {
  PLUGINS,
};
